import { GEOMETRY_TYPE } from '@tmapy/config';
export const getLineStringsFromGeoJSONGeometry = (geometry) => {
    let lineStrings = [];
    // TODO - will works with POLYGONs, now is only for LINE,MULTILINE ???
    switch (geometry.type) {
        case GEOMETRY_TYPE.LINE_STRING: {
            const coordinates = geometry.coordinates;
            lineStrings = [coordinates];
            break;
        }
        case GEOMETRY_TYPE.MULTI_LINE_STRING: {
            const coordinates = geometry.coordinates;
            lineStrings = coordinates;
            break;
        }
    }
    return lineStrings;
};
//# sourceMappingURL=getLineStringsFromGeoJSONGeometry.js.map